var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete"},[(_vm.sureInvoicing)?_c('router-link',{staticClass:"left",attrs:{"to":"/makeinvoice"}},[_vm._v("开具发票")]):_vm._e(),_c('div',{staticClass:"right",on:{"click":_vm.againBuyingTickets}},[_c('div',{staticClass:"surplus"},[_vm._v("重新购票")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }